export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M13 11.365V3c4.5.498 8 4.309 8 8.94 0 1.284-.273 2.5-.756 3.606zm-2 1.154 8.238 4.756c-1.64 2.221-4.267 3.667-7.238 3.667A9 9 0 0 1 11 3z\"/>"
};